import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@thd-olt-component-react/carousel';
import './EtchCarousel.scss';

const EtchCarousel = (props) => {
  const { children, dots } = props;
  const items = children.filter((val) => val)[0];
  return (
    <div className="etch-carousel">
      <Carousel
        autoplay
        continuousLoop
        dotBelow={dots}
        interval="8000"
        multiItem={false}
        showDots={dots}
      >
        {items}
      </Carousel>
    </div>
  );
};

EtchCarousel.propTypes = {
  dots: PropTypes.bool,
  opts: PropTypes.shape({
    options: PropTypes.shape({
      width: PropTypes.number,
      carouselStyle: PropTypes.string,
      carousel: PropTypes.bool,
      showControls: PropTypes.bool,
      showPagination: PropTypes.bool,
      carouselPaginationType: PropTypes.string,
      carouselControlsPosition: PropTypes.string,
      autoStart: PropTypes.bool,
      carouselSpeed: PropTypes.number
    }),
    type: PropTypes.string,
    id: PropTypes.string,
    text: PropTypes.string
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

EtchCarousel.defaultProps = {
  dots: false,
  children: []
};

export default EtchCarousel;
